const stdInfoRoutes = [
  {
    path: "std-info",
    meta: {
      title: "사용자 정보 조회",
      titleEn: "Student Information Inquiry",
    },
    children: [
      {
        path: "index", // std-info/index
        meta: {
          title: "사용자 정보 상세 조회",
          isDynamic: true,
          menuCd: "ADMIN_STUDENT_INFO",
        },
        component: () => import("@/views/std-info/stdInfo/StdInfoIndex.vue"),
      },
      {
        path: "ability-status", // std-info/ability-status
        meta: {
          title: "핵심역량 취득 현황",
          isDynamic: true,
          menuCd: "ABILITY_STATUS",
        },
        component: () => import("@/views/std-info/ability-status/AbilityStatusIndex.vue"),
      },
    ],
  },
];

export default stdInfoRoutes;
